import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  Tooltip,
  breakpoints,
  TooltipModel,
  InfoCircleIcon,
  Colors,
} from '@notino/react-styleguide';

import { useNewPdDesignEnabled } from '../../hooks/useNewPdDesignEnabled';
import {
  TextWrapper,
  CodeWrapper,
  DiscountAmmountWrapper,
  TermsWrapper,
  InstructionTextWrapper,
  TooltipContent,
  InfoIconWrapper,
  DiscountInfoDescription,
} from '../VoucherDiscount/VoucherDiscountInfo/styled';

import { messages } from './messages';

interface IProductDiscountProps {
  discountAmount: string | JSX.Element;
  discountCode: string;
}

export const ProductDiscount: React.FC<IProductDiscountProps> = ({
  discountAmount,
  discountCode,
}) => {
  const newDesign = useNewPdDesignEnabled();

  return (
    <DiscountInfoDescription>
      <TextWrapper newDesign={newDesign}>
        <FormattedMessage
          {...messages.descriptionText}
          values={{
            code: (
              <CodeWrapper newDesign={newDesign}>{discountCode}</CodeWrapper>
            ),
            highlighted: (
              <DiscountAmmountWrapper newDesign={newDesign}>
                {discountAmount}
              </DiscountAmmountWrapper>
            ),
          }}
        />
      </TextWrapper>

      <TermsWrapper newDesign={newDesign}>
        <InstructionTextWrapper newDesign={newDesign}>
          <FormattedMessage {...messages.codeInCart} />
        </InstructionTextWrapper>

        <Tooltip
          interactive={true}
          wrapText={true}
          breakpointToCenter={breakpoints.xl}
          position={TooltipModel.Position.topLeft}
          content={
            <TooltipContent>
              <FormattedMessage {...messages.conditionText} />
            </TooltipContent>
          }
        >
          <InfoIconWrapper newDesign={newDesign}>
            <InfoCircleIcon
              width={newDesign ? '13px' : '12px'}
              height={newDesign ? '13px' : '12px'}
              color={newDesign ? Colors.neutral : Colors.neutralDark}
            />
          </InfoIconWrapper>
        </Tooltip>
      </TermsWrapper>
    </DiscountInfoDescription>
  );
};
